import { FC } from "react";
import { cn } from "../utils/class-names";

export const DiscordIcon: FC<{ className?: string }> = ({ className }) => (
  <svg
    className={cn("h-6 w-6", className)}
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="16"
    viewBox="0 0 21 16"
    fill="none"
  >
    <path
      d="M17.5236 1.48217C16.1762 0.865876 14.7451 0.416711 13.2514 0.166016C13.0633 0.489834 12.8544 0.928547 12.7082 1.27326C11.1194 1.04345 9.54209 1.04345 7.97523 1.27326C7.82898 0.928547 7.60961 0.489834 7.43202 0.166016C5.92788 0.416711 4.49681 0.865876 3.15873 1.48217C0.453298 5.47241 -0.277902 9.36863 0.0876967 13.2126C1.88435 14.5183 3.61835 15.3122 5.32204 15.8346C5.73987 15.2705 6.11592 14.6646 6.43974 14.0274C5.82344 13.7976 5.23848 13.5156 4.67441 13.1813C4.82065 13.0769 4.9669 12.962 5.10269 12.8471C8.50798 14.4035 12.1964 14.4035 15.5598 12.8471C15.7061 12.962 15.8419 13.0769 15.9881 13.1813C15.424 13.5156 14.8391 13.7976 14.2228 14.0274C14.5466 14.6646 14.9227 15.2705 15.3405 15.8346C17.0431 15.3122 18.7876 14.5183 20.5748 13.2126C21.0239 8.76282 19.8635 4.89794 17.5236 1.48217ZM6.90978 10.8415C5.8861 10.8415 5.05044 9.91184 5.05044 8.77327C5.05044 7.6347 5.8652 6.70499 6.90978 6.70499C7.94389 6.70499 8.78996 7.6347 8.76907 8.77327C8.76907 9.91184 7.94389 10.8415 6.90978 10.8415ZM13.7737 10.8415C12.7499 10.8415 11.9132 9.91184 11.9132 8.77327C11.9132 7.6347 12.7291 6.70499 13.7737 6.70499C14.8078 6.70499 15.6538 7.6347 15.633 8.77327C15.633 9.91184 14.8182 10.8415 13.7737 10.8415Z"
      fill="currentColor"
    />
  </svg>
);
